export default __webpack_public_path__ + "static/media/G0540.34I-26290_-16163_0.1666261620000.1edaab6e.jpg";